// "Edgar, do it for me": turn plain requests into app actions. Data-changing ones ask first (confirm: true).
const clean = (s) => s.toLowerCase().replace(/^(hey |ok |okay )?edgar[,]?\s*/, "").replace(/^(please |can you |could you |would you |i want to |i'd like to |let's |lets )+/, "").replace(/[?.!]+$/, "").trim();

const PLACES = [
  [/\bkeepers?\b/, "keepers"],
  [/\b(library|drafts?)\b/, "/library"],
  [/\b(dashboard|stats|sales|profits?|numbers)\b/, "/dashboard"],
  [/\b(what'?s it worth|worth queue|buy or pass)\b/, "/research", "worth"],
  [/\b(media|records?|vinyl|books?|games?|cds?|dvds?)\b/, "/research", "media"],
  [/\b(scanner|barcode)\b/, "scan"],
  [/\bresearch\b/, "/research", "single"],
  [/\bbatch(es)?\b|\bbatch list\b|\buploads?\b/, "/batch"],
  [/\bqueue\b/, "/queue"],
  [/\b(inbox|messages?)\b/, "/inbox"],
  [/\b(alerts?|notifications?)\b/, "/alerts"],
  [/\bearnings?\b/, "/earnings"],
  [/\bpay ?outs?\b/, "/payouts"],
  [/\b(team|assistants?)\b/, "/team"],
  [/\b(billing|plan|subscription)\b/, "/billing"],
  [/\bextension\b/, "/extension"],
  [/\blistings?\b/, "/listings"],
  [/\brare finds?\b/, "/rare-finds"],
  [/\b(recommended )?tools\b|\bfunding\b/, "/tools"],
  [/\b(home|create|new listing)\b/, "/"],
];

export function parseAction(text) {
  const t = clean(text);
  let m = t.match(/^(?:start|create|make|begin|open|set up) (?:a |an )?(?:new )?batch(?: (?:called|named|for|titled) (.+))?$/);
  if (m) return { kind: "batch", name: (m[1] || "").replace(/^["']|["']$/g, "").slice(0, 80) };
  m = t.match(/^(?:search|find|look for|look up) (?:my |the )?(?:library|drafts?) (?:for )?(.+)$/) || t.match(/^(?:search for|find|look for) (.+?) in (?:my |the )?(?:library|drafts?)$/);
  if (m) return { kind: "search", q: m[1].trim().slice(0, 80) };
  if (/^(undo|undo that|undo it|undo the last keep|take that back|take it back)$/.test(t)) return { kind: "undo", confirm: true };
  if (/\b(my (work|assignments?|batches|jobs?|tasks?)|what (do|should) i (do|work on)|assigned to me)\b/.test(t) && !/^(open|go to|take me to|show|pull up)\b/.test(t)) return { kind: "work" };
  if (/\b(pay for|afford|fund|financ\w*|short on (cash|money)|low on (cash|money)|buy now,? pay later|pay later|pay in 4|split (the |my )?payments?|klarna|zip pay|zip card|need (more )?(cash|money))\b/.test(t) && !/\b(plan|subscription|pro|billing|snaplist|edgar|answers?|credits?|shipping label)\b/.test(t)) return { kind: "funding" };
  if (/^(sync|refresh|update) (?:my )?ebay\b/.test(t)) return { kind: "sync" };
  if (/^(clear|delete|remove) (?:all )?(?:my |the )?(?:whatnot )?(?:posting )?alerts?$/.test(t)) return { kind: "clear", confirm: true };
  m = t.match(/^(?:how (?:do|can|would) i |help me |i need to |i wanna |need to )?(?:look up|lookup|research|price check|look into|check (?:the )?prices? (?:of|on|for)|check what (?:.+) (?:is|are) worth)\s*(.*)$/);
  if (m && !/\b(library|drafts?)\b/.test(t)) {
    const what = (m[1] || "").replace(/^(a |an |the |my |this |these |some )/, "").trim();
    const many = /(\band\b|,|\b(several|multiple|bunch|lots? of|few|these|all)\b|\b\d+ )/.test(what) || /\b(dvds|cds|records|books|games|blu-?rays|cassettes|vinyls|albums|movies|items|things)\b/.test(what);
    const media = /\b(dvds?|cds?|records?|vinyls?|books?|games?|blu-?rays?|cassettes?|albums?|movies?|lps?)\b/.test(what);
    return { kind: "lookup", what, mode: many ? (media ? "media" : "worth") : "single" };
  }
  m = t.match(/^(?:open|go to|take me to|show me|show|pull up|bring up|switch to) (?:my |the )?(.+)$/);
  if (m) {
    const hit = PLACES.find(([re]) => re.test(m[1]));
    if (hit) return { kind: "open", to: hit[1], mode: hit[2], what: m[1] };
  }
  return null;
}

export const isYes = (s) => /^(yes|yeah|yep|yup|sure|do it|go ahead|ok|okay|please do|confirm|absolutely)\b/.test(clean(s));
export const isNo = (s) => /^(no|nope|nah|cancel|not now|don'?t|stop|never ?mind)\b/.test(clean(s));

export const ASK_FIRST = {
  undo: "Undo your last keep and take it back out of Keepers?",
  clear: "Clear all your Whatnot posting alerts?",
};

let lastKeep = null;
export const rememberKeep = (path) => { lastKeep = path; };
export const lastKeepPath = () => lastKeep;
